import * as Types from '../../types/bff/gql-schema';

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const GetDoctorDiagnosisBookingSchedulesDocument = `
    query GetDoctorDiagnosisBookingSchedules($contactType: DiagnosisContactType!, $doctorId: ID!, $telemedicineTargetType: TelemedicineTargetType!) {
  getDoctorDiagnosisBookingSchedules(
    request: {doctorId: $doctorId, telemedicineTargetType: $telemedicineTargetType, contactType: $contactType}
  ) {
    displayName
    status
    targetDate
    schedules {
      bookingStatus
      endTimeSlot {
        displayTime
        fromDisplayTime
        toDisplayTime
        value
      }
      startTimeSlot {
        displayTime
        fromDisplayTime
        toDisplayTime
        value
      }
      remainingCount
    }
  }
}
    `;
export const useGetDoctorDiagnosisBookingSchedulesQuery = <
      TData = Types.GetDoctorDiagnosisBookingSchedulesQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDoctorDiagnosisBookingSchedulesQueryVariables,
      options?: UseQueryOptions<Types.GetDoctorDiagnosisBookingSchedulesQuery, TError, TData>,
    ) =>
    useQuery<Types.GetDoctorDiagnosisBookingSchedulesQuery, TError, TData>(
      ['GetDoctorDiagnosisBookingSchedules', variables],
      gqlFetcher<Types.GetDoctorDiagnosisBookingSchedulesQuery, Types.GetDoctorDiagnosisBookingSchedulesQueryVariables>(GetDoctorDiagnosisBookingSchedulesDocument, 'GetDoctorDiagnosisBookingSchedules', variables),
      options
    );

useGetDoctorDiagnosisBookingSchedulesQuery.getKey = (variables: Types.GetDoctorDiagnosisBookingSchedulesQueryVariables) => ['GetDoctorDiagnosisBookingSchedules', variables];
;

useGetDoctorDiagnosisBookingSchedulesQuery.fetcher = (variables: Types.GetDoctorDiagnosisBookingSchedulesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDoctorDiagnosisBookingSchedulesQuery, Types.GetDoctorDiagnosisBookingSchedulesQueryVariables>(GetDoctorDiagnosisBookingSchedulesDocument, 'GetDoctorDiagnosisBookingSchedules', variables, options);
export const GetDayOfWeekDocument = `
    query GetDayOfWeek($date: String!) {
  dayOfWeek(date: $date)
}
    `;
export const useGetDayOfWeekQuery = <
      TData = Types.GetDayOfWeekQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDayOfWeekQueryVariables,
      options?: UseQueryOptions<Types.GetDayOfWeekQuery, TError, TData>,
    ) =>
    useQuery<Types.GetDayOfWeekQuery, TError, TData>(
      ['GetDayOfWeek', variables],
      gqlFetcher<Types.GetDayOfWeekQuery, Types.GetDayOfWeekQueryVariables>(GetDayOfWeekDocument, 'GetDayOfWeek', variables),
      options
    );

useGetDayOfWeekQuery.getKey = (variables: Types.GetDayOfWeekQueryVariables) => ['GetDayOfWeek', variables];
;

useGetDayOfWeekQuery.fetcher = (variables: Types.GetDayOfWeekQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDayOfWeekQuery, Types.GetDayOfWeekQueryVariables>(GetDayOfWeekDocument, 'GetDayOfWeek', variables, options);
export const LikeReviewDocument = `
    mutation LikeReview($reviewId: ID!) {
  likeReview(reviewId: $reviewId)
}
    `;
export const useLikeReviewMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.LikeReviewMutation, TError, Types.LikeReviewMutationVariables, TContext>) =>
    useMutation<Types.LikeReviewMutation, TError, Types.LikeReviewMutationVariables, TContext>(
      ['LikeReview'],
      (variables?: Types.LikeReviewMutationVariables) => gqlFetcher<Types.LikeReviewMutation, Types.LikeReviewMutationVariables>(LikeReviewDocument, 'LikeReview', variables)(),
      options
    );
useLikeReviewMutation.fetcher = (variables: Types.LikeReviewMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.LikeReviewMutation, Types.LikeReviewMutationVariables>(LikeReviewDocument, 'LikeReview', variables, options);
export const UnlikeReviewDocument = `
    mutation UnlikeReview($reviewId: ID!) {
  unlikeReview(reviewId: $reviewId)
}
    `;
export const useUnlikeReviewMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UnlikeReviewMutation, TError, Types.UnlikeReviewMutationVariables, TContext>) =>
    useMutation<Types.UnlikeReviewMutation, TError, Types.UnlikeReviewMutationVariables, TContext>(
      ['UnlikeReview'],
      (variables?: Types.UnlikeReviewMutationVariables) => gqlFetcher<Types.UnlikeReviewMutation, Types.UnlikeReviewMutationVariables>(UnlikeReviewDocument, 'UnlikeReview', variables)(),
      options
    );
useUnlikeReviewMutation.fetcher = (variables: Types.UnlikeReviewMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.UnlikeReviewMutation, Types.UnlikeReviewMutationVariables>(UnlikeReviewDocument, 'UnlikeReview', variables, options);
export const GetDoctorByUserDocument = `
    query GetDoctorByUser($doctorPublicId: ID!, $telemedicineEligibleTargetType: TelemedicineTargetType!, $contactType: DiagnosisContactType!, $isSelectedVaccination: Boolean!) {
  getDoctorByUser(doctorPublicId: $doctorPublicId) {
    name
    doctorId
    readyForVideoCall
    detail {
      contractType
      isBookable
      isNonBenefitBookable
      isBookableF2F
      personalHexColor
      presentedAt
      profileImageUrl
      simpleIntroduce
      introduce
      detailImages
    }
    reviewCount
    reviewAverageRating
    hospital {
      doctorHospitalId
      hospitalName
      hospitalAddress {
        detailAddress
        jibunAddress
        roadAddress
      }
      hospitalTelNumber
      geoPoint {
        latitude
        longitude
      }
      brand {
        brandName
        diagnosisFormType
      }
    }
    medicineType
    departmentsV2(contactType: $contactType) {
      description
      id
      isProfessional
      name
    }
    reviewTagGroups {
      count
      name
      receiverId
      receiverType
      tagId
    }
    careers {
      isRepresentative
      careerType
      content
      id
      sequence
    }
    doctorDuties {
      f2f {
        breakEndTime
        breakStartTime
        contactType
        dayOfWeek
        doctorId
        endTime
        hasBreakTime
        id
        isClosed
        startTime
      }
      nonF2f {
        breakEndTime
        breakStartTime
        contactType
        dayOfWeek
        doctorId
        endTime
        hasBreakTime
        id
        isClosed
        startTime
      }
    }
    nonBenefitTreatmentsV2(contactType: $contactType) {
      nonBenefitTreatmentUnitInfos {
        doctorTreatmentMedicineUnitPricingId
        originalPrice
        priceOnUsingPoint
        treatmentMedicineName
        unitDisplayName
        unitTypeDisplayName
        usablePoint
        priceType
        strengthUnit
      }
      treatment {
        categoryId
        id
        isBenefit
        name
      }
    }
    doctorTreatments {
      doctorId
      treatmentId
      treatment {
        id
        name
      }
    }
    treatmentCategoriesV2(contactType: $contactType) {
      doctorTreatments(contactType: $contactType) {
        treatment {
          id
          name
        }
      }
    }
    doctorBadges {
      badges {
        title
        description
        iconUrl
        type
      }
    }
    doctorNotice {
      title
      content
    }
    doctorDiagnosisTypeReviewRatingStatistics {
      diagnosisTypeId
      diagnosisType
      name
      averageRating
      count
    }
    bookingInfo(
      telemedicineEligibleTargetType: $telemedicineEligibleTargetType
      contactType: $contactType
    ) {
      bookingAvailability
      doctorId
      isBookable
      todayBookable
      todayCutoffTime
      todayKickoffTime
      tomorrowBookable
      tomorrowCutoffTime
      tomorrowKickoffTime
    }
    bookingSchedules(
      telemedicineEligibleTargetType: $telemedicineEligibleTargetType
      contactType: $contactType
    ) {
      displayName
      schedules {
        startTimeSlot {
          displayTime
          fromDisplayTime
          toDisplayTime
          value
        }
        endTimeSlot {
          displayTime
          fromDisplayTime
          toDisplayTime
          value
        }
        bookingStatus
        remainingCount
      }
      status
      targetDate
    }
    familyDoctorInfo {
      createdAt
      doctorId
    }
    doctorVaccinations @include(if: $isSelectedVaccination) {
      treatmentId
      treatmentName
      freePolicies {
        id
        name
        targetGroup
      }
      vaccinationTypes {
        vaccinationTypeId
        name
        products {
          vaccineProductId
          vaccinationTypeUnitId
          unit
          price
          product {
            name
          }
        }
      }
    }
  }
}
    `;
export const useGetDoctorByUserQuery = <
      TData = Types.GetDoctorByUserQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDoctorByUserQueryVariables,
      options?: UseQueryOptions<Types.GetDoctorByUserQuery, TError, TData>,
    ) =>
    useQuery<Types.GetDoctorByUserQuery, TError, TData>(
      ['GetDoctorByUser', variables],
      gqlFetcher<Types.GetDoctorByUserQuery, Types.GetDoctorByUserQueryVariables>(GetDoctorByUserDocument, 'GetDoctorByUser', variables),
      options
    );

useGetDoctorByUserQuery.getKey = (variables: Types.GetDoctorByUserQueryVariables) => ['GetDoctorByUser', variables];
;

useGetDoctorByUserQuery.fetcher = (variables: Types.GetDoctorByUserQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDoctorByUserQuery, Types.GetDoctorByUserQueryVariables>(GetDoctorByUserDocument, 'GetDoctorByUser', variables, options);
export const GetDoctorReviewDocument = `
    query GetDoctorReview($doctorReviewRequest: DoctorReviewRequestInput!, $pagingRequest: PagingRequestInput!, $doctorReviewSort: DoctorReviewSort!) {
  doctorReview(
    doctorReviewRequest: $doctorReviewRequest
    pagingRequest: $pagingRequest
    doctorReviewSort: $doctorReviewSort
  ) {
    doctorId
    reviewId
    createdAt
    content
    maskedPatientName
    diagnosisCategoryName
    comments {
      createdAt
      content
      isBlocked
    }
    isPrivate
    diagnosisId
    rating
    tags {
      tag {
        tagId
        text
      }
    }
    title
    userId
    isBlocked
    likeCount
    isLiked
    doctor {
      doctorId
      medicineType
      name
      profileImage
    }
  }
}
    `;
export const useGetDoctorReviewQuery = <
      TData = Types.GetDoctorReviewQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDoctorReviewQueryVariables,
      options?: UseQueryOptions<Types.GetDoctorReviewQuery, TError, TData>,
    ) =>
    useQuery<Types.GetDoctorReviewQuery, TError, TData>(
      ['GetDoctorReview', variables],
      gqlFetcher<Types.GetDoctorReviewQuery, Types.GetDoctorReviewQueryVariables>(GetDoctorReviewDocument, 'GetDoctorReview', variables),
      options
    );

useGetDoctorReviewQuery.getKey = (variables: Types.GetDoctorReviewQueryVariables) => ['GetDoctorReview', variables];
;

useGetDoctorReviewQuery.fetcher = (variables: Types.GetDoctorReviewQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDoctorReviewQuery, Types.GetDoctorReviewQueryVariables>(GetDoctorReviewDocument, 'GetDoctorReview', variables, options);
export const BestDoctorReviewDocument = `
    query BestDoctorReview($doctorPublicId: ID!) {
  bestDoctorReview(doctorPublicId: $doctorPublicId) {
    doctorId
    reviewId
    createdAt
    content
    maskedPatientName
    diagnosisCategoryName
    comments {
      createdAt
      content
      isBlocked
    }
    isPrivate
    diagnosisId
    rating
    tags {
      tagId
      tag {
        text
      }
    }
    title
    userId
    isBlocked
    likeCount
    isLiked
    doctor {
      doctorId
      medicineType
      name
      profileImage
    }
  }
}
    `;
export const useBestDoctorReviewQuery = <
      TData = Types.BestDoctorReviewQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.BestDoctorReviewQueryVariables,
      options?: UseQueryOptions<Types.BestDoctorReviewQuery, TError, TData>,
    ) =>
    useQuery<Types.BestDoctorReviewQuery, TError, TData>(
      ['BestDoctorReview', variables],
      gqlFetcher<Types.BestDoctorReviewQuery, Types.BestDoctorReviewQueryVariables>(BestDoctorReviewDocument, 'BestDoctorReview', variables),
      options
    );

useBestDoctorReviewQuery.getKey = (variables: Types.BestDoctorReviewQueryVariables) => ['BestDoctorReview', variables];
;

useBestDoctorReviewQuery.fetcher = (variables: Types.BestDoctorReviewQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.BestDoctorReviewQuery, Types.BestDoctorReviewQueryVariables>(BestDoctorReviewDocument, 'BestDoctorReview', variables, options);
export const SearchFamilyDoctorsDocument = `
    query SearchFamilyDoctors($request: FamilyDoctorSearchRequestInput!) {
  searchFamilyDoctors(request: $request) {
    familyDoctorCount
    familyDoctors {
      createdAt
      doctorId
      publicId
      doctorName
      hospitalName
      isAbsent
      isNew
      maxWaitingCount
      medicineType
      profileUrl
      readyForVideoCall
      reviewAverageRating
      reviewCount
      professionalDepartment {
        doctorId
        professionalDepartmentId
        professionalDepartmentName
      }
      bookingInfo(telemedicineEligibleTargetType: null, contactType: null) {
        bookingAvailability
        doctorId
        isBookable
        todayBookable
        todayCutoffTime
        todayKickoffTime
        todaySchedule
        tomorrowBookable
        tomorrowCutoffTime
        tomorrowKickoffTime
        tomorrowSchedule
      }
    }
  }
}
    `;
export const useSearchFamilyDoctorsQuery = <
      TData = Types.SearchFamilyDoctorsQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchFamilyDoctorsQueryVariables,
      options?: UseQueryOptions<Types.SearchFamilyDoctorsQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchFamilyDoctorsQuery, TError, TData>(
      ['SearchFamilyDoctors', variables],
      gqlFetcher<Types.SearchFamilyDoctorsQuery, Types.SearchFamilyDoctorsQueryVariables>(SearchFamilyDoctorsDocument, 'SearchFamilyDoctors', variables),
      options
    );

useSearchFamilyDoctorsQuery.getKey = (variables: Types.SearchFamilyDoctorsQueryVariables) => ['SearchFamilyDoctors', variables];
;

useSearchFamilyDoctorsQuery.fetcher = (variables: Types.SearchFamilyDoctorsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchFamilyDoctorsQuery, Types.SearchFamilyDoctorsQueryVariables>(SearchFamilyDoctorsDocument, 'SearchFamilyDoctors', variables, options);
export const AddFamilyDoctorDocument = `
    mutation AddFamilyDoctor($doctorId: ID!) {
  addFamilyDoctor(doctorId: $doctorId)
}
    `;
export const useAddFamilyDoctorMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.AddFamilyDoctorMutation, TError, Types.AddFamilyDoctorMutationVariables, TContext>) =>
    useMutation<Types.AddFamilyDoctorMutation, TError, Types.AddFamilyDoctorMutationVariables, TContext>(
      ['AddFamilyDoctor'],
      (variables?: Types.AddFamilyDoctorMutationVariables) => gqlFetcher<Types.AddFamilyDoctorMutation, Types.AddFamilyDoctorMutationVariables>(AddFamilyDoctorDocument, 'AddFamilyDoctor', variables)(),
      options
    );
useAddFamilyDoctorMutation.fetcher = (variables: Types.AddFamilyDoctorMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.AddFamilyDoctorMutation, Types.AddFamilyDoctorMutationVariables>(AddFamilyDoctorDocument, 'AddFamilyDoctor', variables, options);
export const RemoveFamilyDoctorsDocument = `
    mutation RemoveFamilyDoctors($doctorIds: [ID!]!) {
  removeFamilyDoctors(request: {doctorIds: $doctorIds})
}
    `;
export const useRemoveFamilyDoctorsMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.RemoveFamilyDoctorsMutation, TError, Types.RemoveFamilyDoctorsMutationVariables, TContext>) =>
    useMutation<Types.RemoveFamilyDoctorsMutation, TError, Types.RemoveFamilyDoctorsMutationVariables, TContext>(
      ['RemoveFamilyDoctors'],
      (variables?: Types.RemoveFamilyDoctorsMutationVariables) => gqlFetcher<Types.RemoveFamilyDoctorsMutation, Types.RemoveFamilyDoctorsMutationVariables>(RemoveFamilyDoctorsDocument, 'RemoveFamilyDoctors', variables)(),
      options
    );
useRemoveFamilyDoctorsMutation.fetcher = (variables: Types.RemoveFamilyDoctorsMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.RemoveFamilyDoctorsMutation, Types.RemoveFamilyDoctorsMutationVariables>(RemoveFamilyDoctorsDocument, 'RemoveFamilyDoctors', variables, options);